type Item<T> = {
  label: string;
  key: T;
  children: JSX.Element;
  Renderer?: () => JSX.Element;
  id?: string;
};
const Tabs = <T,>({
  onChange,
  className = "",
  items = [],
  activeKey,
  showDivider = false,
  activeClass = "dr-border-doctor-darwin-accent-bright-blue-800 BodyBody2Bold dr-text-darwin-touch-primary-primary",
  underline = false,
  inActiveClass = "dr-border-b-transparent dr-text-doctor-darwin-neutral-500 BodyBody2Regular",
  tabsContainerClassName = "dr-px-24 space-x-16",
  headerClassName = "",
  headerRightComponent = <></>,
  headerLeftComponent = <></>,
  bodyClassName = "h-full",
  style = {},
  headerStyle,
  transition = true,
}: {
  style?: React.CSSProperties;
  className?: string;
  onChange: (key: T) => void;
  activeKey: string;
  showDivider?: boolean;
  activeClass?: string;
  inActiveClass?: string;
  underline?: boolean;
  headerClassName?: string;
  tabsContainerClassName?: string;
  headerRightComponent?: JSX.Element;
  headerLeftComponent?: JSX.Element;
  items: Array<Item<T>>;
  bodyClassName?: string;
  headerStyle?: React.CSSProperties;
  transition?: boolean;
}) => {
  return (
    <div style={style} className={`${className}`}>
      <div
        className={`flex items-center justify-between ${headerClassName}`}
        style={headerStyle}
      >
        <div className="flex items-center">
          {headerLeftComponent}
          <div
            id="tabs-header-items"
            className={`flex items-center ${tabsContainerClassName}`}
          >
            {items.map((item) => {
              const { Renderer } = item;
              const isActive = item.key === activeKey;
              return Renderer ? (
                <Renderer />
              ) : (
                <div
                  className={`dr-cursor-pointer dr-min-w-max ${
                    underline
                      ? "dr-border-l-none dr-border-r-none dr-border-t-none dr-border-b-2"
                      : ""
                  } ${transition ? "dr-transition-all" : ""} ${
                    isActive ? activeClass : inActiveClass
                  }`}
                  onClick={() => {
                    onChange(item.key);
                  }}
                  key={item.label}
                  id={item.id}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
        {headerRightComponent}
      </div>

      {showDivider ? (
        <div className="dr-w-full dr-h-1 dr-bg-doctor-darwin-neutral-100" />
      ) : (
        <></>
      )}
      <div className={bodyClassName}>
        {items.find((item) => item.key === activeKey)?.children}
      </div>
    </div>
  );
};

export default Tabs;
